module.exports = __webpack_public_path__ + "static/media/brahma_02.7aa13650.png";